import { binCountSessionIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const cancelBinCountSession = {
  name: "cancelBinCountSession" as const,
  input: z.object({ binCountSessionId: binCountSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
